import getApi from '../../api'
import { StatsConversationList } from '../../model/StatsAssistant'

export const listConversations = (page: number, search?: string) =>
  getApi().get<StatsConversationList>('/stats_assistant/conversations', {
    page,
    ...(search ? { search } : {}),
  })
